import axios from 'axios';
import { useEffect, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import SearchBar from '../SearchBar';

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function Users() {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 20;

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/getUsers.php`);
            setUsers(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error('Error fetching users:', error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleSearch = (value) => {
        setSearchTerm(value);
        setCurrentPage(0);
    };

    const filteredUsers = users.filter((user) =>
        Object.values(user).some(
            (value) =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
        )
    );

    const pageCount = Math.ceil(filteredUsers.length / itemsPerPage);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    return (
        <div>
            <h2>Users</h2>
            <div className="search-bar">
                <SearchBar onSearch={handleSearch} />
            </div>
            {isLoading ? (
                <p>Loading users...</p>
            ) : (
                <div>
                    <table>
                        <thead>
                            <tr>
                                <th>User ID</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Created At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers
                                .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
                                .map((user) => (
                                    <tr key={user.userId}>
                                        <td>{user.userId}</td>
                                        <td>{user.name}</td>
                                        <td>{user.email}</td>
                                        <td>{user.createdAt}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>

                    <ReactPaginate
                        previousLabel={<FaChevronLeft />}
                        nextLabel={<FaChevronRight />}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        forcePage={currentPage}
                    />
                </div>
            )}
        </div>
    );
}

export default Users;
